import { Divider, Flex, Text } from "@chakra-ui/react";

interface DividerTextProps {
  label: string;
}

export function DividerText({ label }: DividerTextProps) {
  return (
    <Flex
      py={0}
      px={3}
      gap={3}
      alignItems={"center"}
      alignSelf={"stretch"}
      color={"gray.500"}
      flexWrap={"nowrap"}
    >
      <Divider />
      <Text variant="text_xs_medium" whiteSpace="nowrap">
        {label}
      </Text>
      <Divider />
    </Flex>
  );
}
